"use client";

import { COOKIE_CONSENT_REOPEN_EVENT } from "@/components/ui/cookie-consent";

/**
 * Quiet footer entry point to the consent banner. With the geo-gated regime
 * (2026-07-11) visitors outside opt-in jurisdictions never see the banner
 * automatically, so this link is their opt-out path (and keeps the privacy
 * policy's "manage your preferences" promise true everywhere).
 */
export function CookiePreferencesLink() {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event(COOKIE_CONSENT_REOPEN_EVENT))}
      className="tlsr-focus"
      style={{
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        color: "var(--tls-fg-subtle)",
        fontFamily: "var(--tls-font-body)",
        fontWeight: 600,
        fontSize: "0.6875rem",
        letterSpacing: "0.04em",
        textDecoration: "underline",
        textUnderlineOffset: 3,
        minHeight: 44,
      }}
    >
      Cookie preferences
    </button>
  );
}
